import React from 'react';
import { inject, observer, Observer } from 'mobx-react';
import Box from '@mui/material/Box';

import DriverProfilePieChart from '../DriverProfilePieChart';
import _, { flowRight as compose } from 'lodash';
import styles, * as E from 'components/styled/DriverProfileDashbroad/styles';
import { withRouter } from 'providers';

class DriverProfileDashbroad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'ALL_TIME',
      statistics: [],
    };

    this.toggleTab = this.toggleTab.bind(this);
  }

  componentDidMount() {
    const { driverStore, driver } = this.props;
    driverStore.getStatistics(driver.id).then((response) => {
      if (response && Array.isArray(response.data)) {
        this.setState({ statistics: response.data });
      } else {
        this.setState({ statistics: [] });
      }
    }).catch((error) => {
      this.setState({ statistics: [] });
    });
  }

  toggleTab = (id) => () => {
    this.setState({ activeTab: id });
  };

  render() {
    const { activeTab, statistics } = this.state;
    const fallbackStatistic = {
      clientLogos: [],
      clients: [],
      driver_pool: [],
      id: null,
      shipment_early_count: 0,
      shipment_failed_count: 0,
      shipment_late_count: 0,
      shipment_successful_count: 0,
      total_assignments: 0,
      total_shipments: 0,
      type: activeTab,
      verify: false,
    };
    const filtered = statistics.filter((s) => s.type === activeTab);
    const statistic = filtered.length > 0 ? filtered : [fallbackStatistic];

    return (
      <E.Container>
        <E.Tabs>
          <E.Tab className={activeTab === 'ALL_TIME' ? 'active' : ''} onClick={this.toggleTab('ALL_TIME')}>{`All-Time`}</E.Tab>
          <E.Tab className={activeTab === 'past7' ? 'active' : ''} onClick={this.toggleTab('past7')}>{`Past Week`}</E.Tab>
          <E.Tab className={activeTab === 'past30' ? 'active' : ''} onClick={this.toggleTab('past30')}>{`Past Month`}</E.Tab>
        </E.Tabs>
        {statistic.length > 0 && (
          <E.Content>
            <Box>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <E.Box>
                    <E.Text1>{`Average Performance`}</E.Text1>
                    <DriverProfilePieChart statistic={statistic[0]} />
                  </E.Box>
                </Box>
                <Box sx={{ flex: 1, ...styles.colShipmentInfo }}>
                  <Box sx={{ display: 'flex', ...styles.row }}>
                    <Box sx={{ flex: 1, ...styles.col }}>
                      <E.Box>
                        <E.Label>{`Total Assignments`}</E.Label>
                        <E.Text2>{statistic[0].total_assignments}</E.Text2>
                      </E.Box>
                    </Box>
                    <Box sx={{ flex: 1, ...styles.col }}>
                      <E.Box>
                        <E.Label>{`Total Shipments`}</E.Label>
                        <E.Text2>{statistic[0].total_shipments}</E.Text2>
                      </E.Box>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', ...styles.row }}>
                    <Box sx={{ flex: 1 }}>
                      <E.Box>
                        <E.Label>{`Driver Pools`}</E.Label>
                        <E.Text3>{statistic[0].driver_pool.join(', ')}</E.Text3>
                      </E.Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <E.BoxClient>
                    <E.LabelClient>{`Clients`}</E.LabelClient>
                    <E.ClientList>
                      {statistic[0].clientLogos &&
                        Object.values(statistic[0].clientLogos).length > 0 &&
                        Object.values(statistic[0].clientLogos)
                          .filter((l) => l)
                          .map((l, i) => <E.ClientLogo key={`client-logo-${i}`} src={l} width={39} height={39} />)}
                    </E.ClientList>
                  </E.BoxClient>
                </Box>
              </Box>
            </Box>
          </E.Content>
        )}
      </E.Container>
    );
  }
}
export default compose(withRouter, inject('driverStore'), observer)(DriverProfileDashbroad);
